// shared/common/calendar/CalendarTimeZone.js
import { fromZonedTime, formatInTimeZone } from "date-fns-tz";

export const STORAGE_TIME_ZONE = "Europe/Paris";

export const minutesToHHMM = (min) => {
  const n = Number(min ?? 0);
  const hh = Math.floor(n / 60);
  const mm = n % 60;
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`; 
};

export const hhmmToMinutes = (s) => {
  if (!s || typeof s !== "string" || !s.includes(":")) return null;
  const [hh, mm] = s.split(":").map(Number);
  if (!Number.isFinite(hh) || !Number.isFinite(mm)) return null;
  if (hh < 0 || hh > 23 || mm < 0 || mm > 59) return null;
  return hh * 60 + mm;
};

export const storageSlotToInstant = (date, startMin) => {
  const hhmm = minutesToHHMM(startMin);
  return fromZonedTime(`${date}T${hhmm}:00`, STORAGE_TIME_ZONE);
};

export const addMinutes = (date, minutes) => {
  return new Date(date.getTime() + Number(minutes || 0) * 60_000);
};

export const instantToStorageSlot = (instant) => {
  const date = formatInTimeZone(instant, STORAGE_TIME_ZONE, "yyyy-MM-dd");
  const hhmm = formatInTimeZone(instant, STORAGE_TIME_ZONE, "HH:mm");
  const start_min = hhmmToMinutes(hhmm);

  return {
    date,
    start_min,
    period: start_min < 720 ? "morning" : "afternoon",
  };
};